import { BUILD_ENV } from "../../shared/constants/environment";

// Flip once the v3 SSO backend ticket ships (see wingspan-app-v3-2's
// V3_MIGRATION_TRACKER.md, section /v3/platform/sso).
export const V3_SSO_SUPPORTED = false;

// Mirrors the users-repo authenticationRedirectMap (PR #2511) — no dev/local
// entry exists there either.
const V3_APP_ORIGIN_BY_ENV: Partial<Record<string, string>> = {
  production: "https://my-v3.wingspan.app",
  staging: "https://staging-my-v3.wingspan.app",
  integration: "https://integration-my-v3.wingspan.app"
};

export function shouldRedirectToV3(params: {
  migrateToV3?: boolean;
  authenticationStrategy: "Password" | "SingleSignOn";
}): boolean {
  return (
    !!params.migrateToV3 &&
    (params.authenticationStrategy !== "SingleSignOn" || V3_SSO_SUPPORTED)
  );
}

export function buildV3SignInUrl(email: string): string | null {
  const origin = V3_APP_ORIGIN_BY_ENV[BUILD_ENV as string];
  if (!origin) {
    return null;
  }
  return `${origin}/member/sign-in?email=${encodeURIComponent(email)}`;
}

export function redirectToV3SignIn(email: string): boolean {
  const url = buildV3SignInUrl(email);
  if (!url) {
    return false;
  }
  window.open(url, "_self");
  return true;
}
